export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const HIDE_OVERLAYS = 'HIDE_OVERLAYS';
export const UPDATE_OVERLAY = 'UPDATE_OVERLAY';
